import { Navigate, Outlet } from "react-router-dom";
import useApp from "../../utils/useApp";
import React from "react";

type RequireRoleProps = {
  allowedRoles: string[];
};

export function RequireRole({ allowedRoles }: RequireRoleProps) {
  const { auth }: any = useApp();

  if (!auth?.profile?.role) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(auth.profile.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
